import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";
import { Zap, Target, Cpu, TrendingDown, BarChart3, Layers } from "lucide-react";

export const EASE = [0.22, 1, 0.36, 1];

// Enriched proof-point dataset (numbers + conventional baseline + delta framing + icon).
export const POINTS = [
  { id: "ttv", metric: "Time to Value", conv: "9–12 months to production", pre: "<", value: 60, suffix: " days", tail: "to production", delta: "5x faster deployment", icon: Zap },
  { id: "precision", metric: "Decision Precision", conv: "60–75% accuracy; inconsistent trust", pre: ">", value: 95, suffix: "%", tail: "precision on governed use cases", delta: "+25% accuracy lift", icon: Target },
  { id: "productivity", metric: "Engineering Productivity", conv: "Heavy integration, context & workflow maintenance", pre: "", value: 90, suffix: "%", tail: "higher engineering productivity", delta: "10x developer output", icon: Cpu },
  { id: "tco", metric: "Total Cost of Ownership", conv: "Growing API, integration & maintenance spend", pre: "", value: 50, suffix: "%", tail: "lower TCO", delta: "2x capital efficiency", icon: TrendingDown },
  { id: "impact", metric: "Business Impact", conv: "Isolated gains with limited end-to-end impact", pre: "20–", value: 40, suffix: "%", tail: "improvement in targeted business KPIs", delta: "Compound enterprise ROI", icon: BarChart3 },
  { id: "scale", metric: "Scale & Reusability", conv: "Components rebuilt for every new use case", pre: "60–", value: 80, suffix: "%", tail: "reuse of context, agents & workflow components", delta: "4x component reusability", icon: Layers },
];

export const Counter = ({ value }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!inView) return;
    const c = animate(0, value, { duration: 1.6, ease: EASE, onUpdate: (v) => setN(Math.round(v)) });
    return () => c.stop();
  }, [inView, value]);
  return <span ref={ref}>{n}</span>;
};
